'use strict';
const angular = require('angular');

/*@ngInject*/
export function elasticService($resource) {
  'ngInject';
  return $resource('/api/searches/:controller', {}, {
    searchAuthors: {
      method: 'GET',
      params: {
        controller: 'authors'
      },
      isArray: true
    },
    searchDirectDrMemberAuthors: {
      method: 'GET',
      params: {
        controller: 'direct-dr-member-authors'
      },
      isArray: true
    },
    searchWanted: {
      method: 'GET',
      params: {
        controller: 'wanted'
      },
      isArray: true
    }
  });
}

export default angular.module('dalApp.elastic', [])
  .service('ElasticAPI', elasticService)
  .name;



// WEBPACK FOOTER //
// ./client/components/elastic/elastic.service.js